// extracted by mini-css-extract-plugin
export default {"historyHolder":"History_historyHolder__-lYA3","historyLine":"History_historyLine__whz+b","tailConnector":"History_tailConnector__WZ1lU","tail":"History_tail__GcsIy"};